import React from "react"
import { AppSidebar } from "components/app-sidebar"
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "components/ui/breadcrumb"
import { Separator } from "components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "components/ui/sidebar"
import { BreadcrumbsProvider, useBreadcrumbs } from "contexts/BreadcrumbsContext"

function HeaderBreadcrumbs() {
  const { crumbs } = useBreadcrumbs();
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((c, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 && <BreadcrumbSeparator className="hidden md:block" />}
            <BreadcrumbItem className={idx === 0 ? "hidden md:block" : undefined}>
              {c.href ? (
                <BreadcrumbLink href={c.href}>{c.label}</BreadcrumbLink>
              ) : c.onClick ? (
                <BreadcrumbLink asChild>
                  <span
                    onClick={c.onClick}
                    className="cursor-pointer hover:text-black"
                  >
                    {c.label}
                  </span>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{c.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <BreadcrumbsProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="overflow-hidden">
          <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
            <div className="flex items-center gap-2 px-4">
              <SidebarTrigger className="-ml-1 h-4 w-4" />
              <Separator
                orientation="vertical"
                className="mr-2 data-[orientation=vertical]:h-4"
              />
              <HeaderBreadcrumbs />
            </div>
          </header>
          <div className="flex flex-1 flex-col min-h-0 px-4 pb-4">
            {children}
          </div>
        </SidebarInset>
      </SidebarProvider>
    </BreadcrumbsProvider>
  )
}
